var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSend = function SvgIconSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47 2.465a.6.6 0 0 0-.855.667l1.7 7.648q.085-.003.174.007l6.775.776a.358.358 0 0 1 0 .71l-6.775.777a1 1 0 0 1-.138.008l-1.736 7.809a.6.6 0 0 0 .854.667l18-8.998a.6.6 0 0 0 0-1.073z"
  })));
};
export default SvgIconSend;